export default function PageTitle({ children }) {
  return (
    <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter leading-tight md:leading-none max-w-4xl mx-auto">
      {children}
    </h1>
  );
}
